import { createSvgIcon } from '@material-ui/core/utils';

export const MeshSupervisionIcon = createSvgIcon(
  <>
    <path d="M23.09 4.63a2.074 2.074 0 0 1-2.49 2.03l-3.2 6.4a2.066 2.066 0 0 1-1.49 3.5c-1.14 0-2.07-.92-2.07-2.06 0-.23.04-.45.11-.66l-3.53-3.1c-.33.22-.73.35-1.16.35-.18 0-.35-.02-.51-.06l-1.34 2.4h-.08v.14l-2.4 4.31c.39.38.63.9.63 1.48 0 1.14-.93 2.06-2.07 2.06s-2.06-.92-2.06-2.06A2.066 2.066 0 0 1 4 17.35l3.83-6.84c-.39-.38-.63-.91-.63-1.49 0-1.14.92-2.07 2.06-2.07s2.07.93 2.07 2.07c0 .33-.08.64-.22.92l3.43 3.01c.36-.32.84-.52 1.37-.52.2 0 .4.03.58.08l3.17-6.33c-.43-.38-.7-.93-.7-1.55 0-1.14.92-2.06 2.06-2.06s2.07.92 2.07 2.06Z" />
    <path d="m7.41 13.43-.08.14v-.14h.08zM.47 13.43H1.5v1.03H.47z" />
    <path d="M3.45 13.43v1.03h1.94v-1.03H3.45Zm3.88 0v1.03h1.94v-1.03H7.33Zm3.88 0v1.03h1.95v-1.03h-1.95Zm7.77 0v1.03h1.94v-1.03h-1.94ZM22.86 13.43h1.03v1.03h-1.03z" />
  </>,
  'MeshSupervisionIcon',
);
